import { isConvertibleExtension } from '@picsio/db/src/fileTypes';
import isCropSupportedFormat from './isCropSupportedFormat';

function isAssetConvertibleForBulkCopy(asset) {
  if (!asset) return false;
  if (asset.isConvertibleFormat === false) return false;
  if (asset.isConvertibleFormat === true) return true;
  const ext = (asset.fileExtension || '').toLowerCase();
  return isConvertibleExtension(ext);
}

/**
 * Aggregated selection flags for bulk copy / conversion UI (and server-side parity).
 * `bulkCopyAllConvertible` — every selected asset supports format conversion.
 * `bulkCopyAllCroppable` — every selected asset supports copy-crop (see
 * `@picsio/db` `NON_CROPPABLE_EXTENSIONS` / `NON_CROPPABLE_MIMES`).
 */
export default function computeBulkCopySelectionFlags(assets) {
  if (!Array.isArray(assets) || assets.length === 0) {
    return { bulkCopyAllConvertible: true, bulkCopyAllCroppable: true };
  }
  return {
    bulkCopyAllConvertible: assets.every(isAssetConvertibleForBulkCopy),
    bulkCopyAllCroppable: assets.every(
      (a) => a && isCropSupportedFormat(a.mimeType, a.fileExtension),
    ),
  };
}
